import { NextPage } from 'next'
import { PageContainer } from '../../components/layout'
import { PrivacyRequestContainer } from '../../containers/privacy-request'
import { Routes } from '@dtx-company/true-common/src/constants/routes'

const PrivacyRequest: NextPage = () => {
  return (
    <PageContainer page={Routes.PRIVACY_REQUEST} disableSideNav>
      <PrivacyRequestContainer />
    </PageContainer>
  )
}

export default PrivacyRequest
